import { useMemo } from 'react';
export function useConnectDropTarget(connector) {
  return useMemo(function () {
    return connector.hooks.dropTarget();
  }, [connector]);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dnd/dist/esm/hooks/useDrop/connectors.js
// module id = null
// module chunks = 